import { IconProps } from "@utils/types/components";

export const Menu2Icon = ({
  width,
  height,
  color = "currentcolor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill={color}>
        <path d="M14.335 3.043H1.384a.769.769 0 01-.572-.265.962.962 0 01-.238-.64c0-.24.086-.47.238-.64a.769.769 0 01.572-.266h12.951c.215 0 .42.096.572.266.152.17.238.4.238.64s-.086.47-.238.64a.768.768 0 01-.572.265zM1.384 7.568h12.951c.215 0 .42.095.572.265.152.17.238.4.238.64s-.086.47-.238.64a.768.768 0 01-.572.266H1.384a.769.769 0 01-.572-.266.962.962 0 01-.238-.64c0-.24.086-.47.238-.64a.769.769 0 01.572-.265zM1.384 13.904h12.951c.215 0 .42.096.572.265.152.17.238.4.238.64s-.086.47-.238.64a.768.768 0 01-.572.266H1.384a.768.768 0 01-.572-.265.962.962 0 01-.238-.64c0-.24.086-.47.238-.64a.769.769 0 01.572-.266zM18.38 3.947c-.894 0-1.619-.81-1.619-1.81s.725-1.81 1.62-1.81c.893 0 1.618.81 1.618 1.81s-.725 1.81-1.619 1.81zM18.38 10.284c-.894 0-1.619-.81-1.619-1.81s.725-1.811 1.62-1.811c.893 0 1.618.81 1.618 1.81s-.725 1.81-1.619 1.81zM18.38 16.62c-.894 0-1.619-.81-1.619-1.81s.725-1.811 1.62-1.811c.893 0 1.618.81 1.618 1.81s-.725 1.81-1.619 1.81z" />
      </g>
    </svg>
  );
};
